import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`

const Anomaly = ({num}) => {

   const anomalyImages = [
      <g>
         <polygon fill="none" strokeWidth="14px" points="3459.23 1945.79 3436.66 1961.73 3459.23 1977.66 3436.66 1993.59 3436.66 2035.73 3535.32 2035.73 3535.32 1993.59 3557.88 1977.66 3535.32 1961.73 3557.88 1945.79 3535.32 1929.86 3557.88 1913.93 3535.32 1898 3535.32 1848.02 3436.66 1848.02 3436.66 1898 3459.23 1913.93 3436.66 1929.86 3459.23 1945.79"/>
         <g>
            <StyledRect x="3585.78" y="1784.36" width="151.94" height="151.94"/>
            <path d="M3728.31,1794.36v132.53H3595.78V1794.36h132.53m10-10H3585.78v152.53h152.53V1784.36Z"/>
            <path d="M3657.29,1833H3640v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>,

      <g>
         <polygon fill="none" strokeWidth="14px" points="1265.09 492.01 1242.52 507.94 1265.09 523.87 1242.52 539.8 1242.52 581.95 1341.17 581.95 1341.17 539.8 1363.74 523.87 1341.17 507.94 1363.74 492.01 1341.17 476.07 1363.74 460.14 1341.17 444.21 1341.17 394.24 1242.52 394.24 1242.52 444.21 1265.09 460.14 1242.52 476.07 1265.09 492.01"/>
         <g>
            <StyledRect x="1391.63" y="330.57" width="151.94" height="151.94"/>
            <path d="M1534.17,340.57V473.1H1401.63V340.57h132.54m10-10H1391.63V483.1h152.54V330.57Z"/>
            <path d="M1463.15,379.21H1445.9v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>,

      <g>
         <polygon fill="none" strokeWidth="14px" points="310.13 910.64 287.56 926.57 310.13 942.5 287.56 958.43 287.56 1000.58 386.22 1000.58 386.22 958.43 408.78 942.5 386.22 926.57 408.78 910.64 386.22 894.71 408.78 878.77 386.22 862.84 386.22 812.87 287.56 812.87 287.56 862.84 310.13 878.77 287.56 894.71 310.13 910.64"/>
         <g>
            <StyledRect x="436.68" y="749.2" width="151.94" height="151.94"/>
            <path d="M579.21,759.2V891.74H446.68V759.2H579.21m10-10H436.68V901.74H589.21V749.2Z"/>
            <path d="M508.19,797.85H491v-11.7c13.94,0,18.89-3,22.64-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>,

      <g>
         <polygon fill="none" strokeWidth="14px" points="223.82 2373.86 201.26 2389.79 223.82 2405.73 201.26 2421.66 201.26 2463.8 299.91 2463.8 299.91 2421.66 322.48 2405.73 299.91 2389.79 322.48 2373.86 299.91 2357.93 322.48 2342 299.91 2326.07 299.91 2276.09 201.26 2276.09 201.26 2326.07 223.82 2342 201.26 2357.93 223.82 2373.86"/>
         <g>
            <StyledRect x="350.37" y="2212.43" width="151.94" height="151.94"/>
            <path d="M492.91,2222.43V2355H360.37V2222.43H492.91m10-10H350.37V2365H502.91V2212.43Z"/>
            <path d="M421.89,2261.07H404.64v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>   
   ]

  const index = num-1
  return (
    anomalyImages[index]
  )
}

export default Anomaly
